import { apiClient } from "../common/axiosInstance"
import { IFormData, IUserResponse } from "./types";
import { handleAxiosError } from "../common/handleAxiosError";

interface IUpdateUser {
  formData: IFormData;
  userName: string;
}

export const updateUser = async ({ formData, userName }: IUpdateUser) => {
  try {
    const { data }: { data: IUserResponse } = await apiClient.put(`/users/update?username=${userName}`, formData)
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al actualizar el usuario");
  }
}